module.exports = __webpack_public_path__ + "img/NielsKlim_Utklipp.96b9d913.jpg";